import { NotificationsList } from 'notifications-from-civil-status/view-models/notifications-list';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<NotificationsList, keyof NotificationsList>[] = [
  {
    id: 'typeEvent',
    label: 'Registro',
  },
  {
    id: 'scope',
    label: 'Ambito',
  },
  {
    id: 'code',
    label: 'Codice comunicazione',
  },
  {
    id: 'owners',
    label: 'Intestatario',
  },
  {
    id: 'dateFormation',
    label: 'Data formazione',
  },
  {
    id: 'municipalityFormation',
    label: 'Comune di formazione',
  },
  {
    id: 'idAnsc',
    label: 'ID Ansc',
    colSpan: 2,
  },
  {
    id: 'state',
    label: 'Stato aggiornamento',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
